import React from 'react';
import Grid from '@material-ui/core/Grid';

const Footer = () => {
	return (
		<div style={{width: '100%', background: '#212121'}}>
			<Grid container
				direction="row"
				justify="space-around"
				alignItems="center"
				spacing={3}
				style={{marginTop: '1rem', paddingTop: '1rem', paddingBottom: '1.5rem', textAlign: 'center'}}
			>
				<Grid item xs={12} sm={6} style={{padding: '0rem'}}>
					Developed By Ishmam
				</Grid>
				<Grid item xs={12} sm={6} style={{padding: '0rem'}}>
					<small>With the help of</small>&nbsp; <img style={{width: '70px'}} src="https://pixabay.com/static/img/logo.png" alt="Pixabay logo" />
				</Grid>
			</Grid>
		</div>
	)
}

export default Footer;